import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import logo from "../../assets/logo-1.png";
import "./Footer.css";

const FOOTER_LINKS = {
  Services: [
    { label: "Window Repair", to: "/window-repair" },
    { label: "Screen Repair", to: "/services" },
    { label: "Glass Repair", to: "/services" },
    { label: "Key Cutting", to: "/services" },
    { label: "Paint Matching", to: "/services" },
  ],
  Shop: [
    { label: "Tools & Supplies", to: "/services" },
    { label: "Power Tools", to: "/services" },
    { label: "Fasteners", to: "/services" },
    { label: "Plumbing", to: "/services" },
    { label: "Lawn & Garden", to: "/services" },
  ],
  Company: [
    { label: "About Us", to: "/about" },
    { label: "Contact", to: "/contact" },
    { label: "Projects & Tips", to: "/" },
    { label: "FAQs", to: "/" },
  ],
};

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        {/* Brand col */}
        <div className="footer__brand">
          <div className="footer__logo">
            <img
              src={logo}
              alt="City Hardware logo"
              className="footer__logo-img"
            />
            <div>
              <div className="footer__logo-city">CITY</div>
              <div className="footer__logo-hardware">HARDWARE</div>
            </div>
          </div>
          <p className="footer__tagline">
            Your neighborhood solution for every fix. Detroit's trusted hardware
            store since day one.
          </p>

          <div className="footer__contact-list">
            <a
              href="https://maps.google.com"
              className="footer__contact-item"
              target="_blank"
              rel="noopener noreferrer">
              <MapPin size={14} />
              16325 W Warren Ave, Detroit, MI 48228
            </a>
            <a href="tel:+13135828860" className="footer__contact-item">
              <Phone size={14} />
              (313) 582-8860
            </a>
            <a
              href="mailto:hello@cityhardware.com"
              className="footer__contact-item">
              <Mail size={14} />
              hello@cityhardware.com
            </a>
            <span className="footer__contact-item">
              <Clock size={14} />
              Mon–Fri 9AM–6PM · Closed Sunday.
            </span>
          </div>
        </div>

        {/* Nav cols */}
        {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
          <div key={heading} className="footer__col">
            <h4 className="footer__col-heading">{heading}</h4>
            <ul className="footer__col-links">
              {links.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="footer__col-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <span className="footer__copy">
            © {new Date().getFullYear()} City Hardware. All rights reserved.
            Detroit, MI.
          </span>
          <span className="footer__sub-links">
            <Link to="/">Privacy Policy</Link>
            <span>·</span>
            <Link to="/">Terms of Use</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
